import {
  analyticsTabsLabelsMap,
  EAnalyticsState,
  ordersTabsLabelsMap,
  playersTabsLabelsMap,
  portalBuilderTabsLabelsMap,
  pricingTabsLabelsMap,
  reportsTabsLabelsMap,
  settingTabsLabelsMap,
  themeTabsLabelsMap
} from 'constants/navigation';

import { ESettingsState } from 'components/Settings/Settings.types';

export const tabLabelsMap: Record<string, string> = {
  ...ordersTabsLabelsMap,
  ...reportsTabsLabelsMap,
  ...analyticsTabsLabelsMap,
  ...playersTabsLabelsMap,
  ...portalBuilderTabsLabelsMap,
  ...pricingTabsLabelsMap,
  ...settingTabsLabelsMap,
  ...themeTabsLabelsMap
};

export const landingPageTrackingMap: Record<
  string,
  { tab: string; defaultSection: string }
> = {
  statistics: { tab: 'Analytics', defaultSection: EAnalyticsState.BUSINESS },
  settings: { tab: 'Settings', defaultSection: ESettingsState.DEVELOPER_SETTINGS },
  bundles: { tab: 'Bundles', defaultSection: '' }
};
